import { initComponentStore } from "@/utils/mobx";
import { appStore } from "@/app_store";


export class DashboardSectionStore {
    selectedPath: string | null = null;
    selectedIsDir: boolean = false;

    constructor() {
        initComponentStore(this);
    }

    get projects() {
        return appStore.project.all;
    }

    onFileBrowserSelect(path: string | null, isDir: boolean) {
        this.selectedPath = path;
        this.selectedIsDir = path !== null && isDir;
    }

    selectProject(id: string) {
        appStore.project.selectProject(id);
    }

    openSelectedAsProject() {
        if (!this.selectedPath || !this.selectedIsDir) return;
        const existing = appStore.project.findByRelativePath(this.selectedPath);
        if (existing) {
            appStore.project.selectProject(existing.id);
            return;
        }
        const name = this.selectedPath.split("/").filter(Boolean).pop() ?? "project";
        appStore.project.create(name, this.selectedPath);
    }
}
